import { authFetch } from "./api";

export const getDeadlineCorporate = async ({ month, year, sapCode, groupBy, activityDescription }: { month?: number; year?: number; sapCode?: string; groupBy?: 'task' | 'company'; activityDescription?: string | null }) => {
   try {
      let url = `${import.meta.env.VITE_API_URL}/report/deadline-corporate`
      const queryParams = new URLSearchParams()
  
      if (month) queryParams.append("month", String(month)) // I mesi sono indicizzati da 0
      if (year) queryParams.append("year", String(year))
      if (sapCode) queryParams.append("sapCode", sapCode)
      if (groupBy) queryParams.append("groupBy", groupBy)
      if (activityDescription) queryParams.append("activityDescription", activityDescription)

      if (queryParams.toString()) {
        url += `?${queryParams.toString()}`
      }
      
      const response = await authFetch(url)
  
      const json = await response.json()
      if (!response.ok) {
        console.error("Errore durante il recupero delle attività:", json)
        return { data: null, error: json.message || "Errore sconosciuto" }
      }
      return  { data: json as DeadlineCorporate[], error: null}
  
    } catch (error) {
      console.error("Errore durante il recupero delle attività:", error)
      return { data: null, error: error instanceof Error ? error.message : "Errore sconosciuto" }
    }
}


export type DeadlineCorporate ={
  description: string;
  completed: number;
  notCompleted: number;
}